import { render, staticRenderFns } from "./AgreementRenderer.vue?vue&type=template&id=8f5de850&scoped=true&"
import script from "./AgreementRenderer.vue?vue&type=script&lang=js&"
export * from "./AgreementRenderer.vue?vue&type=script&lang=js&"
import style0 from "./AgreementRenderer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AgreementRenderer.vue?vue&type=style&index=1&id=8f5de850&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5de850",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VThemeProvider})
